import Vue from 'vue';
import {hasPermission} from "@/core/directives/permission";
import HelperService from '@/core/services/helper.service';
import EventBus from "@/plugins/event-bus";
import {getMonthAgo, getMonthCurrent} from "@/core/directives/dates";

const vibrate = (interval = [500, 100, 500]) => {
  if (window.navigator && typeof window.navigator.vibrate === 'function') {
    window.navigator.vibrate(interval);
  }
}

Vue.use({
  install(Vue) {
    Vue.prototype.$hasPermission = hasPermission;
    Vue.prototype.$getMonthAgo = getMonthAgo;
    Vue.prototype.$getMonthCurrent = getMonthCurrent;
    Vue.prototype.$isMobileDevice = HelperService.isMobileDevice;
    Vue.prototype.$evBus = EventBus;
    Vue.prototype.$vibrate = vibrate;
    Vue.prototype.$generalGoBack = async function (vm) {
      if (window.history.length <= 1) {
        await vm.$router.push('/');
      } else {
        await vm.$router.back();
      }
    };
  }
});
